module.exports = __webpack_public_path__ + "img/loading_tj.5454a340.gif";